// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__FZ4hm","menu":"Header_menu__1BAdw","Menus":"Header_Menus__8nF7+"};